/**
 * Notice API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The InlineObject2 model module.
 * @module model/InlineObject2
 * @version 1.0
 */
class InlineObject2 {
    /**
     * Constructs a new <code>InlineObject2</code>.
     * @alias module:model/InlineObject2
     */
    constructor() { 
        
        InlineObject2.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>InlineObject2</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/InlineObject2} obj Optional instance to populate.
     * @return {module:model/InlineObject2} The populated <code>InlineObject2</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new InlineObject2();

            if (data.hasOwnProperty('title')) {
                obj['title'] = ApiClient.convertToType(data['title'], 'String');
            }
            if (data.hasOwnProperty('preview')) {
                obj['preview'] = ApiClient.convertToType(data['preview'], 'String');
            }
            if (data.hasOwnProperty('body')) {
                obj['body'] = ApiClient.convertToType(data['body'], 'String');
            }
            if (data.hasOwnProperty('programmed_at')) {
                obj['programmed_at'] = ApiClient.convertToType(data['programmed_at'], 'String');
            }
            if (data.hasOwnProperty('has_email')) {
                obj['has_email'] = ApiClient.convertToType(data['has_email'], 'Boolean');
            }
            if (data.hasOwnProperty('has_notification')) {
                obj['has_notification'] = ApiClient.convertToType(data['has_notification'], 'Boolean');
            }
            if (data.hasOwnProperty('is_promo')) {
                obj['is_promo'] = ApiClient.convertToType(data['is_promo'], 'Boolean');
            }
            if (data.hasOwnProperty('notification_title')) {
                obj['notification_title'] = ApiClient.convertToType(data['notification_title'], 'String');
            }
            if (data.hasOwnProperty('notification_text')) {
                obj['notification_text'] = ApiClient.convertToType(data['notification_text'], 'String');
            }
            if (data.hasOwnProperty('segment_operator')) {
                obj['segment_operator'] = ApiClient.convertToType(data['segment_operator'], 'String');
            }
        }
        return obj;
    }


}

/**
 * title
 * @member {String} title
 */
InlineObject2.prototype['title'] = undefined;

/**
 * preview
 * @member {String} preview
 */
InlineObject2.prototype['preview'] = undefined;

/**
 * body
 * @member {String} body
 */
InlineObject2.prototype['body'] = undefined;

/**
 * programmed at
 * @member {String} programmed_at
 */
InlineObject2.prototype['programmed_at'] = undefined;

/**
 * has email
 * @member {Boolean} has_email
 */
InlineObject2.prototype['has_email'] = undefined;

/**
 * has notification
 * @member {Boolean} has_notification
 */
InlineObject2.prototype['has_notification'] = undefined;

/**
 * is a promo
 * @member {Boolean} is_promo
 */
InlineObject2.prototype['is_promo'] = undefined;

/**
 * title of the notification
 * @member {String} notification_title
 */
InlineObject2.prototype['notification_title'] = undefined;

/**
 * text of the notification
 * @member {String} notification_text
 */
InlineObject2.prototype['notification_text'] = undefined;

/**
 * segment join operator (or/and)
 * @member {String} segment_operator
 */
InlineObject2.prototype['segment_operator'] = undefined;






export default InlineObject2;

